<template>
    <v-form v-model="isValidForm" :disabled="isFormDisabled" lazy-validation ref="feedbackForm">
        <v-container v-if="questions.length">
            <v-row>
                <v-col
                    v-for="question in questions"
                    cols="12"
                    :key="question.id"
                >
                    <template v-if="question.type === 'number'">
                        <v-subheader>
                            {{ question.name }} (+{{ question.bonus }})
                        </v-subheader>

                        <v-row dense justify="center">
                            <v-col cols="auto">
                                <v-rating
                                    v-model="answersModel[question.id]"
                                    hover
                                    length="5"
                                    size="32"
                                />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-if="question.type === 'string'">
                        <v-text-field
                            v-model="answersModel[question.id]"
                            :hint="`Бонус: ${question.bonus}`"
                            :label="question.name"
                            persistent-hint
                        />
                    </template>
                    <template v-if="question.type === 'text'">
                        <v-textarea
                            v-model="answersModel[question.id]"
                            :hint="`Бонус: ${question.bonus}`"
                            :label="question.name"
                            persistent-hint
                        />
                    </template>
                    <template v-if="question.type === 'boolean'">
                        <v-checkbox
                            v-model="answersModel[question.id]"
                            :hint="`Бонус: ${question.bonus}`"
                            :label="question.name"
                            persistent-hint
                        />
                    </template>
                    <template v-if="question.type === 'date'">
                        Datepicker
                    </template>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-btn
                        block
                        color="secondary"
                        :disabled="!isValidForm || isFormDisabled"
                        :loading="isSending"
                        @click="sendAnswers()">
                        Отправить отзыв
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-container v-else>
            <v-row>
                <v-col cols="auto">
                    Выберите другой заказ-наряд для оценки
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import { forEach as _forEach } from 'lodash'
    import moment from 'moment'
    import { mapGetters, mapState } from 'vuex'

    export default {
        name: 'HistoryFeedbackScreen',

        data: () => ({
            answersModel: {},

            isValidForm: true,
            rules: {
                required: (value) => !!value || 'Обязательное поле.',
                string: (value) => (!!value && !!value.length) || 'Обязательное поле.',
            },
        }),

        computed: {
            ...mapState('feedback', {
                isSending: (state) => state.isSending,
            }),

            ...mapGetters({
                getQuestionsByDate: 'feedback/getQuestionsByDate',
                getOrder: 'carHistory/getCarHistoryItem',
            }),

            orderId() {
                return this.$route.params?.orderId
            },

            order() {
                return this.getOrder(this.orderId)
            },

            isFormDisabled() {
                return (this.orderId && !this.order) || this.isSending || !this.questions.length
            },

            questions() {
                const questions = this.getQuestionsByDate(this.order?.date)

                _forEach(questions, (item) => {
                    const items = []
                    let i
                    for (i = 1; i <= item.maxScore; i++) {
                        items.push({
                            value: i,
                            text: i,
                        })
                    }

                    item.items = items
                })

                return questions
            },

            answers() {
                const answers = []

                _forEach(this.answersModel, (result, id) => {
                    answers.push({ id, result })
                })

                return answers
            },
        },

        methods: {
            sendAnswers() {
                if (this.$refs.feedbackForm.validate()) {
                    const orderId = this.order?.id
                    const orderDate = this.order?.date
                    const date = moment().utcOffset(5).unix()
                    const answers = this.answers

                    const params = {
                        orderId,
                        orderDate,
                        date,
                        answers,
                    }

                    this.$store.dispatch('feedback/sendAnswers', params)
                        .then(() => {
                            this.$root.pushNotification({
                                text: 'Отзыв принят',
                                color: 'success',
                            })

                            this.$router.back()
                        })
                        .catch(() => {
                            this.$root.pushNotification({
                                text: 'Ошибка',
                                color: 'error',
                            })
                        })
                }
            },
        },
    }
</script>
